module.exports = __webpack_public_path__ + "img/logo.white.4a860fe2.png";